function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import './dropdown.scss';
import Dropdown from './dropdown.js';
import ListenerDocumentClick from './listenerDocumentClick.js';
import DropdownList from './dropdownList.js';
import DropdownSelected from './dropdownSelected.js';
import dropdownService from './dropdownService.js';

var VanillaDropdown = /*#__PURE__*/function () {
  function VanillaDropdown(element, options) {
    _classCallCheck(this, VanillaDropdown);

    this.element = element;
    this.options = options;
    this.listenerDocumentClick = new ListenerDocumentClick();
    this.dropdown = new Dropdown(this.element);
    this.dropdownService = new dropdownService();
    this.dropdownService.addDropdown(this.dropdown);
    this.init();
    return this;
  }

  _createClass(VanillaDropdown, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.dropdown.preOpen = function () {
        var activeDropdown = _this.dropdownService.getActiveDropdown();

        if (activeDropdown != null && activeDropdown != _this.dropdown) {
          activeDropdown.close();
        }

        _this.dropdownService.setActiveDropdown(_this.dropdown);
      };

      this.dropdown.onOpen = function () {
        _this.listenerDocumentClick._bind();

        _this.listenerDocumentClick.onEmmit = function () {
          _this.dropdown.close();
        };
      };

      var dropdownListElement = this.element.querySelector("vanilla-dropdown-list");
      var dropdownSelectedElement = this.element.querySelector("vanilla-dropdown-selected");
      var dropdownSelectedInstance = new DropdownSelected(dropdownSelectedElement);
      var dropdownListInstance = new DropdownList(dropdownListElement);

      dropdownListInstance.onChange = function (e, value) {
        dropdownSelectedInstance.update(e, value);

        _this.listenerDocumentClick.emmit(e);
      };
    }
  }]);

  return VanillaDropdown;
}();

export { VanillaDropdown as default };